const breadcrumbKey = Symbol("breadcrumbKey");

export { breadcrumbKey };
//# sourceMappingURL=constants.mjs.map
